var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.366 8.063c.938 1.649 6.303 7.014 7.952 7.952l.884-1.238a1 1 0 011.294-.296 11.42 11.42 0 004.583 1.364 1 1 0 01.921.997v4.462a1 1 0 01-.898.995 15.51 15.51 0 01-1.602.082c-8.56 0-19.5-10.94-19.5-19.5C0 2.343.027 1.81.082 1.28a1 1 0 01.995-.898h4.462a1 1 0 01.997.921A11.422 11.422 0 007.9 5.885a1 1 0 01-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357a13.41 13.41 0 01-1.097-3.668H2.01c-.006.166-.009.333-.009.5-.001 7.456 10.043 17.5 17.499 17.5.167 0 .334-.003.5-.01v-2.637a13.406 13.406 0 01-3.668-1.097l-1.357 1.9a12.432 12.432 0 01-1.588-.75l-.058-.033c-1.961-1.116-7.586-6.74-8.702-8.702l-.033-.058a12.442 12.442 0 01-.75-1.588z",
    fill: "#707175"
  })));
}

export default SvgPhone;